import script from "./FeatureCards.vue?vue&type=script&setup=true&lang=js"
export * from "./FeatureCards.vue?vue&type=script&setup=true&lang=js"

import "./FeatureCards.vue?vue&type=style&index=0&id=82fa924c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-82fa924c"]])

export default __exports__